declare const window: { dataLayer: [{ 'gtm.start': number, event: string }] } & Window & typeof globalThis;

export default function gtm() {
  const dataLayer = 'dataLayer';

  window[dataLayer] = window[dataLayer] || [];
  window[dataLayer].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  const script = document.getElementsByTagName('script')[0];
  const j = document.createElement('script');
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GTM_TAG}`;
  if (script.parentNode) {
    script.parentNode.insertBefore(j, script);
  }

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');

  iframe.setAttribute(
    'src',
    `https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_TAG}`,
  );
  iframe.setAttribute('height', '0');
  iframe.setAttribute('width', '0');
  iframe.setAttribute('style', 'display:none;visibility:hidden');
  noscript.appendChild(iframe);
  document.body.appendChild(noscript);

  return true;
}
